import { render, staticRenderFns } from "./RestaurantListing.vue?vue&type=template&id=13c6130d&scoped=true&lang=pug"
import script from "./RestaurantListing.vue?vue&type=script&lang=js"
export * from "./RestaurantListing.vue?vue&type=script&lang=js"
import style0 from "./RestaurantListing.vue?vue&type=style&index=0&id=13c6130d&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13c6130d",
  null
  
)

export default component.exports